module.exports = __webpack_public_path__ + "images/apps/shimo-00e0c7b575da0ea601206753a4f20c3b.png";